import { createReducer, combineReducersWithRoot } from '@common/redux-utils';
import {
  SaveContractStartAction,
  SaveContractSuccessAction,
  SaveContractFailureAction,
  SavePropertyInfoAction,
  SaveAffiliatesInfoAction,
  SaveCustomerInfoAction,
  SaveEscrowInfoAction,
  SaveCoeDateAction,
  GetContactTypesStartAction,
  GetContactTypesSuccessAction,
  GetContactTypesFailureAction,
  GetContactMediumsStartAction,
  GetContactMediumsSuccessAction,
  GetContactMediumsFailureAction,
  GetContactInitiatorsStartAction,
  GetContactInitiatorsSuccessAction,
  GetContactInitiatorsFailureAction,
  GetPropertyTypesStartAction,
  GetPropertyTypesSuccessAction,
  GetPropertyTypesFailureAction,
  GetPropertySaleTypesStartAction,
  GetPropertySaleTypesSuccessAction,
  GetPropertySaleTypesFailureAction,
  GetContractDetailsStartAction,
  GetContractDetailsSuccessAction,
  GetContractDetailsFailureAction,
  GetBillingOptionsStartAction,
  GetBillingOptionsSuccessAction,
  GetBillingOptionsFailureAction,
  GetAssetManagersStartAction,
  GetAssetManagersSuccessAction,
  GetAssetManagersFailureAction,
  LoadInitiatingAgentSuccessAction,
  LoadCooperatingAgentSuccessAction,
  LoadRealEstateAgentSuccessAction,
  LoadBuyerCustomerAction,
  LoadSellerCustomerAction,
  LoadEscrowOfficerAction,
  LoadEscrowOfficeAction,
  LoadTransactionCoordinatorAction,
  SavePaymentInfoStartAction,
  SavePaymentInfoSuccessAction,
  SavePaymentInfoFailureAction,
  ClearBuyerAction,
  ClearSellerAction,
  ClearInitAgentAction,
  ClearCoopAgentAction,
  ClearEscrowOfficerAction,
  ClearTransactionCoordinatorAction,
  RemoveTxCAction,
  RemoveRealEstateAgentAction,
  SearchCommentsByContractInitAction,
  SearchCommentsByContractFailureAction,
  SearchCommentsByContractSuccessAction,
  SelectCommentAction,
  ConvertQuoteToContractAction,
  SaveContractFilesStartAction,
  SaveContractFilesSuccessAction,
  SaveContractFilesFailureAction,
  RemoveContractFileStartAction,
  RemoveContractFileSuccessAction,
  RemoveContractFileFailureAction,
  GetContractFilesStartAction,
  GetContractFilesSuccessAction,
  GetContractFilesFailureAction,
  GetEdocTypesStartAction,
  GetEdocTypesSuccessAction,
  GetEdocTypesFailureAction,
  LoadPropertyManagerAction,
  ClearPropertyManagerAction,
  CancelContractOrderStartAction,
  CancelContractOrderSuccessAction,
  CancelContractOrderFailureAction,
  GetContractCancellationReasonsStartAction,
  GetContractCancellationReasonsSuccessAction,
  GetContractCancellationReasonsFailureAction,
  CalculateContractCancellationRefundStartAction,
  CalculateContractCancellationRefundSuccessAction,
  CalculateContractCancellationRefundFailureAction,
  GetContractCancellationNotificationsStartAction,
  GetContractCancellationNotificationsSuccessAction,
  GetContractCancellationNotificationsFailureAction,
  AddEmailNotificationAction,
  RemoveEmailNotificationAction,
  SetOverrideAction,
  ContractCancellationFormResetAction,
  GetRenewalContractStartAction,
  GetRenewalContractSuccessAction,
  GetRenewalContractFailureAction,
  // GetRenewalChangeFeeStartAction, GetRenewalChangeFeeSuccessAction, GetRenewalChangeFeeFailureAction,
  SendRenewalNoticeStartAction,
  SendRenewalNoticeSuccessAction,
  SendRenewalNoticeFailureAction,
  ActivateContractFailureAction,
  ActivateContractStartAction,
  ActivateContractSuccessAction,
  SetRefundByCheckAction,
  SetPaymentInfoAction,
  SetCancellationRefundAction,
  NoRenewContractStartAction,
  NoRenewContractSuccessAction,
  NoRenewContractFailureAction,
  GetContractNoRenewReasonsStartAction,
  GetContractNoRenewReasonsSuccessAction,
  GetContractNoRenewReasonsFailureAction,
  RemoveNoRenewContractStartAction,
  RemoveNoRenewContractSuccessAction,
  RemoveNoRenewContractFailureAction,
  SetContractMetadataAction,
  SaveOrderTypeAction,
  SetContractIdAction,
  LoadCustomerWorkflowAction,
  SetIsOpenContractAction,
  SearchContractsSuccessAction,
  SearchContractsFailureAction,
  SearchContractsInitAction,
  GetRenewalOptionsStartAction,
  GetRenewalOptionsSuccessAction,
  GetRenewalOptionsFailureAction,
  SearchRelatedContractsInitAction,
  SearchRelatedContractsFailureAction,
  SearchRelatedContractsSuccessAction,
  SavingUSPSAction,
  SetShouldClearAction
} from './contract.actions';
import {
  ContractViewModel,
  EntityViewModel,
  ContractDetailsViewModel,
  PropertyTypeViewModel,
  ContractResaleEmailViewModel,
  NoRenewViewModel,
  ContractMetaDataViewModel,
  ContractSimpleViewModel
} from '@models/Contract';
import { CoverageOption } from '@models/CoverageOption';
import { OptionsViewModel, AddressViewModel, blankStatesVM } from '@models/common.models';
import { CommentViewModel } from '@models/Comment';
import { RealEstateAgentViewModel } from '@models/RealEstateAgent';
import { RealEstateOfficeViewModel } from '@models/RealEstateOffice';
import { EscrowOfficerViewModel } from '@models/EscrowOfficer';
import { EscrowOfficeViewModel } from '@models/EscrowOffice';
import { TransactionCoordinatorViewModel } from '@models/TransactionCoordinator';
import { CustomerViewModel } from '@models/Customer';
import {
  GeneralLoadRealEstateAgentsAction,
  ClearContractDetailsAction,
  ResetContractStateAction
} from './contract.actions';
import { dateParser } from '@common/dateParser';
import { DocumentViewModel } from '@models/Document';
import {
  ContractCancellationModel,
  ContractCancellationNotificationModel,
  ContractPaymentInfoModel
} from '@models/ContractCancellation';
import { PropertyManagerSearchViewModel } from '@models/PropertyManager';
import { PriceAdjustmentViewModel, ProductViewModel, ProductCoverageViewModel } from '@models/Product';

import { isValidEmail } from '@common/validators';
import {
  ContractActionType,
  LoadAffiliatesWorkflowAction,
  LoadPropertyWorkflowAction,
  LoadPriceAdjustmentWorkflowAction
} from './contract.actions';
import {
  ContractResellAction,
  ContractResaleActionType,
  GetContractResaleDataStartAction,
  GetContractResaleDataSuccessAction,
  GetContractResaleDataFailureAction,
  ClearResaleDataAction,
  SaveResaleContractStartAction,
  SaveResaleContractSuccessAction,
  SaveResaleContractFailureAction,
  GetContractResaleNotificationsStartAction,
  GetContractResaleNotificationsSuccessAction,
  GetContractResaleNotificationsFailureAction,
  SendResaleEmailsStartAction,
  SendResaleEmailsSuccessAction,
  SendResaleEmailsFailureAction,
  SetResaleLoadingAction
} from './contract-resale.actions';
import { ContractResaleModalViewModel, ContractOrderType } from '@models/Contract';
import { SaveCoverageAction } from './_components/coverage/_actions/coverage.actions.types';
import {
  initialContractPaymentState,
  ContractPaymentReducer,
  ContractPaymentState
} from './_components/contract-payment/contract-payment.reducer';
import {
  ContractHistoryActionType,
  SearchContractTermStartAction,
  SearchContractTermSuccessAction,
  SearchContractTermFailureAction
} from 'src/contract/contract-history.actions';
import { ContractTermSearchViewModel } from '@models/ContractHistory';
import { OrderEditReducer, initOrderEditState, OrderEditState } from './_components/order-edit/order-edit.reducer';
import { LoadOtherContractInfoAction } from './contract.actions';
import { PropertySaleTypes } from '../_constants/PropertySaleTypes';
import {
  ContractEmailState,
  initContractEmailState,
  ContractEmailReducer
} from 'src/contract/_components/contract-email/contract-email.reducer';
import {
  PaymentEditState,
  initPaymentEditState,
  PaymentEditReducer
} from 'src/contract/_components/payment-edit/payment-edit.reducer';
import { ContractSearchViewModel } from '@models/ServiceWorkOrder';
import {
  ContractBalancesReducer,
  initContractBalancesState,
  ContractBalancesState
} from './_components/contract-balances/contract-balances.reducer';

/*
These are the reducers for the page.
Think of these as the "event handlers" for the page.
They process business logic and update the state within the page's store
*/

export interface ContractState {
  readonly searchQuery: string | null;
  readonly searchLoading: boolean;
  readonly searchPageCount: number;
  readonly searchPageNumber: number;
  readonly searchPageSize: number;
  readonly searchResults: ContractSearchViewModel[];
  readonly searchResultsTotalCount: number;
  readonly id?: number;
  readonly contractAn?: string;
  readonly message?: string;
  readonly contractVM: ContractViewModel | null;
  readonly contractMetadata?: ContractMetaDataViewModel;
  readonly isNextDisabled?: boolean;
  readonly contactTypes: Array<OptionsViewModel>;
  readonly contactMediums: Array<OptionsViewModel>;
  readonly contactInitiators: Array<OptionsViewModel>;
  readonly propertyTypes: Array<PropertyTypeViewModel>;
  readonly propertySaleTypes: Array<OptionsViewModel>;

  readonly isLoadingResale?: boolean;
  readonly contractResaleDate?: Date;

  readonly isOpenContract?: boolean;

  readonly billingOptions: Array<OptionsViewModel>;
  readonly assetManagers: Array<OptionsViewModel>;

  readonly total: Array<any>;
  readonly totalPrice: number;
  readonly extraCharge: number;

  readonly initAgent?: RealEstateAgentViewModel;
  readonly coopAgent?: RealEstateAgentViewModel;
  readonly initOffice?: RealEstateOfficeViewModel;
  readonly coopOffice?: RealEstateOfficeViewModel;
  readonly escrowOfficer: EscrowOfficerViewModel | null;

  readonly transactionCoordinator: Array<TransactionCoordinatorViewModel>;
  readonly buyerCustomer?: CustomerViewModel;
  readonly sellerCustomer?: CustomerViewModel;
  readonly propertyManager?: PropertyManagerSearchViewModel;
  readonly escrowOffice: EscrowOfficeViewModel | null;
  readonly additionalRealEstateAgents: Array<RealEstateAgentViewModel>;
  readonly transCoordId?: number;
  readonly contractEntities: Array<EntityViewModel>;
  readonly isPaymentDateInvalid: boolean;

  readonly contractDetailsVM?: ContractDetailsViewModel;
  readonly commentsQuery: string | null;
  readonly commentsLoading: boolean;
  readonly commentsPageCount: number;
  readonly commentsPageNumber: number;
  readonly commentsPageSize: number;
  readonly commentsResults: CommentViewModel[];
  readonly selectedCommentText: string;
  readonly documents: DocumentViewModel[];
  readonly edocTypes: OptionsViewModel[];

  readonly renewalOptions: ProductCoverageViewModel[];

  readonly loadingContractAgents: {
    [property: string]: RealEstateAgentViewModel;
  };

  readonly contractCancellationReasons: Array<OptionsViewModel>;
  // TODO: GET THE TYPE FOR THIS
  readonly refund: ContractCancellationModel | null;
  readonly paymentInfo: ContractPaymentInfoModel | null;
  readonly cancellationNotifications: Array<ContractCancellationNotificationModel>;
  readonly emailNotifications: Array<string>;
  readonly addressOverride: boolean;
  readonly refundByCheck: boolean;
  readonly contractResaleModalVM?: ContractResaleModalViewModel;
  readonly resaleNotifications: Array<ContractResaleEmailViewModel>;
  readonly resaleEmailNotifications: Array<string>;
  readonly totalAdjustment: number;
  readonly sentEmails?: boolean;
  readonly activationLoading: boolean;
  readonly payment: ContractPaymentState;
  readonly orderEdit: OrderEditState;
  readonly noRenew: NoRenewViewModel;
  readonly noRenewReasons: Array<OptionsViewModel>;

  readonly orderType?: ContractOrderType;

  readonly historyLoading: boolean;
  readonly historyOrderBy: string;
  readonly historyPageCount: number;
  readonly historyPageNumber: number;
  readonly historyPageSize: number;
  readonly historyQuery: string | null;
  readonly historyResults: Array<ContractTermSearchViewModel>;

  readonly contractEmail: ContractEmailState;
  readonly paymentEdit: PaymentEditState;
  readonly contractBalances: ContractBalancesState;

  readonly relatedContractsLoading: boolean;
  readonly relatedContractsPageCount: number;
  readonly relatedContractsPageNumber: number;
  readonly relatedContractsPageSize: number;
  readonly relatedContractsResults: Array<ContractSimpleViewModel>;

  readonly isSavingUSPS: boolean;
  readonly shouldClear: boolean;
}

export const initialTxC = {
  id: 0,
  name: '',
  accountId: 0,
  transCoordType: {} as OptionsViewModel,
  transCoordStatus: {} as OptionsViewModel,
  officeId: 0,
  parentId: 0,
  address: {} as AddressViewModel,
  emailAddress: '',
  directPhone: '',
  directFax: '',
  onlineOrders: false,
  usps: false,
  fax: false,
  email: false
} as TransactionCoordinatorViewModel;

var c = {
  id: 0,
  contractAn: '',
  assetManager: {} as OptionsViewModel,
  assetManagerId: 0,
  assetId: '',
  buyerId: 0,
  contactName: '',
  contactType: {} as OptionsViewModel,
  contactMedium: {} as OptionsViewModel,
  contactInit: {} as OptionsViewModel,
  coopAgentId: 0,
  coopOfficeId: 0,
  comprehensiveOption: false,
  coverageDate: dateParser.now().toDate(),
  coverageOptions: [] as Array<CoverageOption>,
  employeeDiscount: {} as PriceAdjustmentViewModel,
  escrowOfficerId: 0,
  escrowId: 0,
  escrowOneTimeFax: '',
  escrowComments: '',
  initAgentId: 0,
  initOfficeId: 0,
  propertyAddress: {} as AddressViewModel,
  propertyManagerId: 0,
  propertyType: {} as PropertyTypeViewModel,
  propertySaleType: {} as OptionsViewModel,
  mailReturned: 0,
  productGroup: {} as OptionsViewModel,
  product: {} as ProductViewModel,
  productChannel: {} as OptionsViewModel,
  priceAdjustment: {} as PriceAdjustmentViewModel,
  priceAdjustmentAmount: 0,
  priceAdjustmentNotes: '',
  employeeDiscountAmount: 0,
  orderDate: dateParser.now().toDate(),
  sellerCoverage: false,
  sellerCoverageDate: dateParser.now().toDate(),
  sellerCoverageEndDate: dateParser.now().toDate(),
  firstBilling: {} as OptionsViewModel,
  laterBilling: {} as OptionsViewModel,
  sellerId: 0,
  totalPrice: 0,
  buyerTotalPrice: 0,
  sellerTotalPrice: 0,
  transactionCoordinatorIds: [],
  txCOneTimeFax: '',
  // yearBuilt: 0,
  additionalRealEstateAgentIds: [],
  fileNumber: '',
  transCoordId: undefined,
  contractEntities: [],
  contractStatus: {} as OptionsViewModel,
  extraCharge: 0,
  noRenew: {} as NoRenewViewModel,
  noRenewReasons: {} as OptionsViewModel
} as ContractViewModel;

var emmptyNoRenew = {
  noRenewCd: 0
} as NoRenewViewModel;

// This is the initial state of the reducer
const initialState: ContractState = {
  searchQuery: null,
  searchLoading: false,
  searchPageCount: 0,
  searchPageNumber: 1,
  searchPageSize: 10,
  searchResults: [],
  searchResultsTotalCount: 0,

  totalAdjustment: 0,
  message: '',
  contractVM: c,
  contactInitiators: [],
  contactMediums: [],
  contactTypes: [],
  propertyTypes: [],
  propertySaleTypes: [],
  billingOptions: [],
  assetManagers: [],

  total: [],
  totalPrice: 0,
  extraCharge: 0,
  additionalRealEstateAgents: [],
  transactionCoordinator: [],
  contractEntities: [],
  transCoordId: 0,
  isPaymentDateInvalid: false,

  commentsQuery: null,
  commentsLoading: false,
  commentsPageCount: 0,
  commentsPageNumber: 1,
  commentsPageSize: 10,
  commentsResults: [],
  selectedCommentText: '',
  loadingContractAgents: {},
  escrowOffice: null,
  escrowOfficer: null,

  documents: [],
  edocTypes: [],

  isLoadingResale: false,

  contractCancellationReasons: [],
  refund: null,
  paymentInfo: null,
  cancellationNotifications: [],
  emailNotifications: [],
  addressOverride: false,
  refundByCheck: false,
  resaleNotifications: [],
  resaleEmailNotifications: [],
  activationLoading: false,
  payment: initialContractPaymentState,
  orderEdit: initOrderEditState,
  noRenew: emmptyNoRenew,
  noRenewReasons: [],

  orderType: ContractOrderType.DTC,

  historyLoading: false,
  historyOrderBy: '',
  historyPageCount: 0,
  historyPageNumber: 1,
  historyPageSize: 10,
  historyQuery: null,
  historyResults: [],
  renewalOptions: [],

  contractEmail: initContractEmailState,
  paymentEdit: initPaymentEditState,
  contractBalances: initContractBalancesState,

  relatedContractsLoading: false,
  relatedContractsPageCount: 0,
  relatedContractsPageNumber: 1,
  relatedContractsPageSize: 10,
  relatedContractsResults: [],

  isSavingUSPS: false,
  shouldClear: true
};

// Reducers for each action type delcared here
// Each takes the current state, the action that caused it, and should return the new state as a result of that action
function handleSaveContractStart(state: ContractState, action: SaveContractStartAction) {
  return {
    ...state,
    message: action.message
  };
}

function handleSaveContractSuccess(state: ContractState, action: SaveContractSuccessAction) {
  return {
    ...state,
    message: action.message,
    id: action.contractId
  };
}

function handleSaveContractFailure(state: ContractState, action: SaveContractFailureAction) {
  return {
    ...state,
    message: action.errorMessage
  };
}

function handleSavingUSPS(state: ContractState, action: SavingUSPSAction) {
  return {
    ...state,
    isSavingUSPS: action.isSaving
  };
}

function handleGetContactInitiatorsStart(state: ContractState, action: GetContactInitiatorsStartAction): ContractState {
  return {
    ...state,
    message: 'GETTING CONTACT INITIATORS'
  };
}

function handleGetContactInitiatorsSuccess(
  state: ContractState,
  action: GetContactInitiatorsSuccessAction
): ContractState {
  return {
    ...state,
    contactInitiators: action.contactInitiators
  };
}

function handleGetContactInitiatorsFailure(
  state: ContractState,
  action: GetContactInitiatorsFailureAction
): ContractState {
  return {
    ...state,
    message: action.errorMessage
  };
}

function handleGetContactMediumsStart(state: ContractState, action: GetContactMediumsStartAction): ContractState {
  return {
    ...state,
    message: 'GETTING CONTACT MEDIUMS'
  };
}

function handleGetContactMediumsSuccess(state: ContractState, action: GetContactMediumsSuccessAction): ContractState {
  return {
    ...state,
    contactMediums: action.contactMediums
  };
}

function handleGetContactMediumsFailure(state: ContractState, action: GetContactMediumsFailureAction): ContractState {
  return {
    ...state,
    message: action.errorMessage
  };
}

function handleGetContactTypesStart(state: ContractState, action: GetContactTypesStartAction): ContractState {
  return {
    ...state,
    message: 'GETTING CONTACT TYPES'
  };
}

function handleGetContactTypesSuccess(state: ContractState, action: GetContactTypesSuccessAction): ContractState {
  return {
    ...state,
    contactTypes: action.contactTypes
  };
}

function handleGetContactTypesFailure(state: ContractState, action: GetContactTypesFailureAction): ContractState {
  return {
    ...state,
    message: action.errorMessage
  };
}

function handleGetPropertyTypesStart(state: ContractState, action: GetPropertyTypesStartAction): ContractState {
  return {
    ...state,
    message: 'GETTING PROPERTY TYPES'
  };
}

function handleGetPropertyTypesSuccess(state: ContractState, action: GetPropertyTypesSuccessAction): ContractState {
  return {
    ...state,
    propertyTypes: action.propertyTypes
  };
}

function handleGetPropertyTypesFailure(state: ContractState, action: GetPropertyTypesFailureAction): ContractState {
  return {
    ...state,
    message: action.errorMessage
  };
}

function handleGetPropertySaleTypesStart(state: ContractState, action: GetPropertySaleTypesStartAction): ContractState {
  return {
    ...state,
    message: 'GETTING PROPERTY SALES TYPES'
  };
}

function handleGetPropertySaleTypesSuccess(
  state: ContractState,
  action: GetPropertySaleTypesSuccessAction
): ContractState {
  return {
    ...state,
    propertySaleTypes: action.propertySaleTypes
  };
}

function handleGetPropertySaleTypesFailure(
  state: ContractState,
  action: GetPropertySaleTypesFailureAction
): ContractState {
  return {
    ...state,
    message: action.errorMessage
  };
}

function handleSavePropertyInfo(state: ContractState, action: SavePropertyInfoAction): ContractState {
  let contractVM = { ...state.contractVM, ...action.contractVM };
  let cVM = action.contractVM;
  if (cVM) {
    contractVM.contactType = state.contactTypes.filter(type => type.id === +cVM.contactType.id)[0] || cVM.contactType;
    contractVM.contactMedium =
      state.contactMediums.filter(medium => medium.id === +cVM.contactMedium.id)[0] || cVM.contactMedium;
    contractVM.contactInit =
      state.contactInitiators.filter(initiator => initiator.id === +cVM.contactInit.id)[0] || cVM.contactInit;
    contractVM.propertyType =
      state.propertyTypes.filter(type => type.id === +cVM.propertyType.id)[0] || cVM.propertyType;
    contractVM.propertySaleType =
      state.propertySaleTypes.filter(type => type.id === +cVM.propertySaleType.id)[0] || cVM.propertySaleType;
    // if (state.contractVM && (state.contractVM.propertyType.id !== action.contractVM.propertyType.id)) {
    //     contractVM.product = {} as ProductViewModel;
    //     contractVM.coverageOptions = [];
    // }
  }
  return {
    ...state,
    message: 'SUCCESS - save Property Info done',
    contractVM: contractVM
  };
}

function handleSaveOrderType(state: ContractState, action: SaveOrderTypeAction): ContractState {
  return {
    ...state,
    orderType: action.orderType
  };
}

function handleSaveAffiliatesInfo(state: ContractState, action: SaveAffiliatesInfoAction): ContractState {
  var contractVM = { ...state.contractVM } as ContractViewModel;
  let cVM = action.contractVM;
  if (cVM) {
    contractVM.initAgentId = cVM.initAgentId;
    contractVM.initOfficeId = cVM.initOfficeId;
    contractVM.coopAgentId = cVM.coopAgentId;
    contractVM.coopOfficeId = cVM.coopOfficeId;
    contractVM.escrowComments = cVM.escrowComments;
    contractVM.escrowId = cVM.escrowId;
    contractVM.escrowOfficerId = cVM.escrowOfficerId;
    contractVM.escrowOneTimeFax = cVM.escrowOneTimeFax;
    contractVM.estimatedCoeDate = cVM.estimatedCoeDate;
    contractVM.fileNumber = cVM.fileNumber;
    contractVM.txCOneTimeFax = cVM.txCOneTimeFax;
    contractVM.assetManagerId = cVM.assetManagerId;
    contractVM.assetManager = state.assetManagers.filter(manager => manager.id === +cVM.assetManagerId)[0];
    contractVM.assetId = cVM.assetId;
  }
  if (
    state.initAgent &&
    state.initAgent !== undefined &&
    state.initAgent.id !== undefined &&
    state.initAgent.id !== contractVM.initAgentId
  ) {
    contractVM.initAgentId = state.initAgent.id;
  }
  if (
    state.initOffice &&
    state.initOffice !== undefined &&
    state.initOffice.id !== undefined &&
    state.initOffice.id !== contractVM.initOfficeId
  ) {
    contractVM.initOfficeId = state.initOffice.id;
  }
  if (
    state.coopAgent &&
    state.coopAgent !== undefined &&
    state.coopAgent.id !== undefined &&
    state.coopAgent.id !== contractVM.coopAgentId
  ) {
    contractVM.coopAgentId = state.coopAgent.id;
  }
  if (
    state.coopOffice &&
    state.coopOffice !== undefined &&
    state.coopOffice.id !== undefined &&
    state.coopOffice.id !== contractVM.coopOfficeId
  ) {
    contractVM.coopOfficeId = state.coopOffice.id;
  }
  if (state.additionalRealEstateAgents && state.additionalRealEstateAgents.length > 0) {
    contractVM.additionalRealEstateAgentIds = [];
    state.additionalRealEstateAgents.forEach(agent => {
      if (agent.id) {
        contractVM.additionalRealEstateAgentIds.push(agent.id); // contractVM.additionalRealEstateAgentIds = [...contractVM.additionalRealEstateAgentIds, agent.id];
      }
    });
  }
  if (
    state.escrowOfficer &&
    state.escrowOfficer.id !== undefined &&
    state.escrowOfficer.id !== contractVM.escrowOfficerId
  ) {
    contractVM.escrowOfficerId = state.escrowOfficer.id;
  }
  if (state.escrowOffice && state.escrowOffice.id > 0 && state.escrowOffice.id !== contractVM.escrowId) {
    contractVM.escrowId = state.escrowOffice.id;
  }
  if (
    state.contractVM &&
    state.contractVM.transactionCoordinatorIds &&
    state.contractVM.transactionCoordinatorIds.length > 0
  ) {
    contractVM.transactionCoordinatorIds = [];
    state.contractVM.transactionCoordinatorIds.forEach(tc => {
      contractVM.transactionCoordinatorIds.push(tc);
    });
  }
  return {
    ...state,
    message: 'SUCCESS - save Realty Info done',
    contractVM: contractVM
  };
}
function handleSaveCustomerInfo(state: ContractState, action: SaveCustomerInfoAction): ContractState {
  var contractVM = { ...state.contractVM } as ContractViewModel;
  let cVM = action.contractVM;
  if (cVM) {
    contractVM.buyerId = cVM.buyerId;
    contractVM.sellerId = cVM.sellerId;
    contractVM.propertyManagerId = cVM.propertyManagerId;
  }
  if (
    state.buyerCustomer &&
    state.buyerCustomer !== undefined &&
    state.buyerCustomer.id > 0 &&
    state.buyerCustomer.id !== contractVM.buyerId
  ) {
    contractVM.buyerId = state.buyerCustomer.id;
  }
  if (
    state.sellerCustomer &&
    state.sellerCustomer !== undefined &&
    state.sellerCustomer.id > 0 &&
    state.sellerCustomer.id !== contractVM.sellerId
  ) {
    contractVM.sellerId = state.sellerCustomer.id;
  }
  if (
    state.propertyManager !== undefined &&
    state.propertyManager.id > 0 &&
    state.propertyManager.id !== contractVM.propertyManagerId
  ) {
    contractVM.propertyManagerId = state.propertyManager.id;
  }

  return {
    ...state,
    message: 'SUCCESS - save Customer Info done',
    contractVM: contractVM
  };
}
function handleSaveEscrowInfo(state: ContractState, action: SaveEscrowInfoAction): ContractState {
  var contractVM = { ...state.contractVM } as ContractViewModel;
  let cVM = action.contractVM;
  if (cVM) {
    contractVM.escrowOfficerId = cVM.escrowOfficerId;
    contractVM.escrowId = cVM.escrowId;
    contractVM.escrowOneTimeFax = cVM.escrowOneTimeFax;

    contractVM.fileNumber = cVM.fileNumber;
    contractVM.estimatedCoeDate = cVM.estimatedCoeDate;
    contractVM.assetManagerId = cVM.assetManagerId;
    contractVM.assetManager = state.assetManagers.filter(manager => manager.id === +cVM.assetManagerId)[0];
    contractVM.assetId = cVM.assetId;
    contractVM.estimatedCoeDate = cVM.estimatedCoeDate;
    contractVM.fileNumber = cVM.fileNumber;
  }
  if (
    state.escrowOfficer &&
    state.escrowOfficer.id !== undefined &&
    state.escrowOfficer.id !== contractVM.escrowOfficerId
  ) {
    contractVM.escrowOfficerId = state.escrowOfficer.id;
  }
  if (state.escrowOffice && state.escrowOffice.id > 0 && state.escrowOffice.id !== contractVM.escrowId) {
    contractVM.escrowId = state.escrowOffice.id;
  }

  if (
    state.contractVM &&
    state.contractVM.transactionCoordinatorIds &&
    state.contractVM.transactionCoordinatorIds.length > 0
  ) {
    contractVM.transactionCoordinatorIds = [];
    state.contractVM.transactionCoordinatorIds.forEach(tc => {
      contractVM.transactionCoordinatorIds.push(tc);
    });
  }

  return {
    ...state,
    message: 'SUCCESS - save Escrow Info done',
    contractVM: contractVM
  };
}

function handleSaveCoeDate(state: ContractState, action: SaveCoeDateAction): ContractState {
  return {
    ...state,
    contractVM: {
      ...state.contractVM,
      estimatedCoeDate: action.coeDate
    } as ContractViewModel
  };
}

function handleGetContractDetailsStart(state: ContractState, action: GetContractDetailsStartAction): ContractState {
  return {
    ...state,
    message: 'GETTING CONTRACT DETAILS'
  };
}

function handleGetContractDetailsSuccess(state: ContractState, action: GetContractDetailsSuccessAction): ContractState {
  if (!action.contractDetailsVM) {
    return state;
  }

  return {
    ...state,
    contractDetailsVM: action.contractDetailsVM,
    noRenew: action.contractDetailsVM.noRenew,
    message: 'SUCCESS - get contract details done - ' + action.contractDetailsVM.id
  };
}

function handleGetContractDetailsFailure(state: ContractState, action: GetContractDetailsFailureAction): ContractState {
  if (!action.errorMessage) {
    return state;
  }

  return {
    ...state,
    message: 'ERROR - get contract details failed - ' + action.errorMessage
  };
}

function handleClearContractDetails(state: ContractState, action: ClearContractDetailsAction): ContractState {
  return {
    ...state,
    contractDetailsVM: undefined
  };
}

function handleGetBillingOptionsStart(state: ContractState, action: GetBillingOptionsStartAction): ContractState {
  return {
    ...state,
    message: 'GETTING BILLING OPTIONS'
  };
}

function handleGetBillingOptionsSuccess(state: ContractState, action: GetBillingOptionsSuccessAction): ContractState {
  return {
    ...state,
    billingOptions: action.billingOptions,
    message: 'SUCCESS - GOT BILLING OPTIONS'
  };
}

function handleGetBillingOptionsFailure(state: ContractState, action: GetBillingOptionsFailureAction): ContractState {
  return {
    ...state,
    message: action.errorMessage
  };
}

function handleLoadInitAgentSuccess(state: ContractState, action: LoadInitiatingAgentSuccessAction): ContractState {
  return {
    ...state,
    initAgent: action.initAgent,
    initOffice: action.initOffice
  };
}

function handleLoadCoopAgentSuccess(state: ContractState, action: LoadCooperatingAgentSuccessAction): ContractState {
  return {
    ...state,
    coopAgent: action.coopAgent,
    coopOffice: action.coopOffice
  };
}

function handleLoadRealEstateAgentSuccess(
  state: ContractState,
  action: LoadRealEstateAgentSuccessAction
): ContractState {
  let additionalRealEstateAgents = state.additionalRealEstateAgents.slice(0);
  let foundIndex = additionalRealEstateAgents.findIndex(obj => obj.id === action.realEstateAgent.id);
  if (foundIndex > -1) {
    additionalRealEstateAgents.splice(foundIndex, 1, action.realEstateAgent);
  } else {
    additionalRealEstateAgents.push(action.realEstateAgent);
  }
  let newState = {
    ...state,
    additionalRealEstateAgents: additionalRealEstateAgents
  };
  return newState;
}

function handleLoadEscrowOfficer(state: ContractState, action: LoadEscrowOfficerAction): ContractState {
  return {
    ...state,
    escrowOfficer: action.escrowOfficer
  };
}

function handleLoadTransactionCoordinator(
  state: ContractState,
  action: LoadTransactionCoordinatorAction
): ContractState {
  var contract = state.contractVM;
  if (!contract) {
    return state;
  }

  if (!contract.transactionCoordinatorIds || contract.transactionCoordinatorIds[0] === null) {
    contract.transactionCoordinatorIds = [action.transactionCoordinator];
    return {
      ...state,
      contractVM: contract,
      transactionCoordinator: [...state.transactionCoordinator, action.transactionCoordinator]
    };
  }

  contract.transactionCoordinatorIds = contract.transactionCoordinatorIds.slice(0);
  let foundIndex = contract.transactionCoordinatorIds.findIndex(obj => obj.id === action.transactionCoordinator.id);
  if (foundIndex > -1) {
    contract.transactionCoordinatorIds.splice(foundIndex, 1, action.transactionCoordinator);
  } else {
    contract.transactionCoordinatorIds.push(action.transactionCoordinator);
  }

  return {
    ...state,
    contractVM: contract,
    transactionCoordinator: [...state.transactionCoordinator, action.transactionCoordinator]
  };
}

function handleLoadBuyerCustomer(state: ContractState, action: LoadBuyerCustomerAction): ContractState {
  // NOTE: ANY TYPE USED HERE BC OF USE OF TWO DIFFERENT MODELS FOR CONTRACTVM AND CONTRACTDETAILSVM
  const address = action.buyerCustomer.addresses[0];
  const buyerCustomer: any = {
    buyerId: action.buyerCustomer.id,
    buyerName: action.buyerCustomer.name,
    buyerEmailAddress: action.buyerCustomer.emailAddress,
    buyerPhone1: action.buyerCustomer.phone,
    buyerPhone2: action.buyerCustomer.phone2,
    buyerAddressLine1: (address || {}).line1,
    buyerAddressLine2: (address || {}).line2,
    buyerAddressCity: (address || {}).city,
    buyerAddressState: ((address || {}).state || {}).abbreviation,
    buyerAddressZip: (address || {}).zip,
    addresses: action.buyerCustomer.addresses.map((a: AddressViewModel) => {
      return {
        id: a.id,
        buyerAddressLine1: a.line1,
        buyerAddressLine2: a.line2,
        buyerAddressCity: a.city,
        buyerAddressState: a.state
          ? {
              id: a.state.id,
              name: a.state.name,
              abbreviation: a.state.abbreviation
            }
          : blankStatesVM,
        buyerAddressZip: a.zip
      };
    })
  };

  const contract: any = {
    ...state.contractDetailsVM,
    ...buyerCustomer,
    buyer: action.buyerCustomer
  };

  return {
    ...state,
    contractDetailsVM: contract,
    buyerCustomer: action.buyerCustomer
  };
}

function handleLoadSellerCustomer(state: ContractState, action: LoadSellerCustomerAction): ContractState {
  // NOTE: ANY TYPE USED HERE BC OF USE OF TWO DIFFERENT MODELS FOR CONTRACTVM AND CONTRACTDETAILSVM
  const address = action.sellerCustomer.addresses[0];
  const sellerCustomer: any = {
    sellerId: action.sellerCustomer.id,
    sellerName: action.sellerCustomer.name,
    sellerEmailAddress: action.sellerCustomer.emailAddress,
    sellerPhone1: action.sellerCustomer.phone,
    sellerPhone2: action.sellerCustomer.phone2,
    sellerAddressLine1: address ? address.line1 : '',
    sellerAddressLine2: address ? address.line2 : '',
    sellerAddressCity: address ? address.city : '',
    sellerAddressState: address ? address.state.abbreviation : '',
    sellerAddressZip: address ? address.zip : '',
    addresses: action.sellerCustomer.addresses.map((a: AddressViewModel) => {
      return {
        id: a.id,
        sellerAddressLine1: a.line1,
        sellerAddressLine2: a.line2,
        sellerAddressCity: a.city,
        sellerAddressState: a.state
          ? {
              id: a.state.id,
              name: a.state.name,
              abbreviation: a.state.abbreviation
            }
          : blankStatesVM,
        sellerAddressZip: a.zip
      };
    })
  };

  const contract: any = {
    ...state.contractDetailsVM,
    ...sellerCustomer,
    seller: action.sellerCustomer
  };

  return {
    ...state,
    contractDetailsVM: contract,
    sellerCustomer: action.sellerCustomer
  };
}

function handleLoadPropertyManager(state: ContractState, action: LoadPropertyManagerAction): ContractState {
  if (!action.propertyManager) {
    return state;
  }
  return {
    ...state,
    propertyManager: action.propertyManager,
    contractVM: {
      ...state.contractVM!,
      propertyManagerId: action.propertyManager.id
    }
  };
}

function handleLoadEscrowOffice(state: ContractState, action: LoadEscrowOfficeAction): ContractState {
  return {
    ...state,
    escrowOffice: action.escrowOffice
  };
}

function handleSavePaymentInfoStart(state: ContractState, action: SavePaymentInfoStartAction) {
  return {
    ...state,
    isNextDisabled: true,
    message: action.message
  };
}

function handleSavePaymentInfoSuccess(state: ContractState, action: SavePaymentInfoSuccessAction): ContractState {
  let newContractVM = state.contractVM
    ? {
        ...state.contractVM,
        firstBilling: action.firstBilling || ({} as OptionsViewModel),
        laterBilling: action.laterBills || ({} as OptionsViewModel)
      }
    : null;
  let button: HTMLElement | null = document.getElementById('wizardNextButton');
  if (button) {
    (button as HTMLButtonElement).disabled = false;
  }
  return {
    ...state,
    isNextDisabled: false,
    message: action.message,
    contractVM: newContractVM
  };
}

function handleSavePaymentInfoFailure(state: ContractState, action: SavePaymentInfoFailureAction) {
  let button: HTMLElement | null = document.getElementById('wizardNextButton');
  if (button) {
    (button as HTMLButtonElement).disabled = false;
  }
  return {
    ...state,
    isNextDisabled: false,
    message: action.errorMessage
  };
}

function handleClearBuyer(state: ContractState, action: ClearBuyerAction): ContractState {
  return {
    ...state,
    buyerCustomer: undefined
  };
}

function handleClearSeller(state: ContractState, action: ClearSellerAction): ContractState {
  return {
    ...state,
    sellerCustomer: undefined
  };
}

function handleClearPropertyManager(state: ContractState, action: ClearPropertyManagerAction): ContractState {
  if (!state.contractVM) {
    return state;
  }

  return {
    ...state,
    propertyManager: undefined,
    contractVM: {
      ...state.contractVM,
      propertyManagerId: 0
    }
  };
}

function handleClearInitAgent(state: ContractState, action: ClearInitAgentAction): ContractState {
  if (!state.contractVM) {
    return state;
  }

  return {
    ...state,
    initAgent: undefined,
    initOffice: undefined,
    contractVM: {
      ...state.contractVM,
      initAgentId: 0,
      initOfficeId: 0
    }
  };
}

function handleClearCoopAgent(state: ContractState, action: ClearCoopAgentAction): ContractState {
  if (!state.contractVM) {
    return state;
  }

  return {
    ...state,
    coopAgent: undefined,
    coopOffice: undefined,
    contractVM: {
      ...state.contractVM,
      coopAgentId: 0,
      coopOfficeId: 0
    }
  };
}

function handleClearEscrowOfficer(state: ContractState, action: ClearEscrowOfficerAction): ContractState {
  return {
    ...state,
    escrowOfficer: null,
    escrowOffice: null
  };
}

function handleClearTransactionCoordinator(
  state: ContractState,
  action: ClearTransactionCoordinatorAction
): ContractState {
  if (!state.contractVM) {
    return state;
  }
  return {
    ...state,
    transactionCoordinator: [],
    contractVM: {
      ...state.contractVM,
      transactionCoordinatorIds: []
    }
  };
}

function handleRemoveTxC(state: ContractState, action: RemoveTxCAction): ContractState {
  var contract: ContractViewModel | null = state.contractVM;

  if (contract && contract.transactionCoordinatorIds) {
    let newList = contract.transactionCoordinatorIds.slice(0);
    const foundIndex = newList.findIndex(x => x.id === action.id);
    if (foundIndex > -1) {
      newList.splice(foundIndex, 1);
    }

    return {
      ...state,
      contractVM: {
        ...contract,
        transactionCoordinatorIds: newList
      }
    };
  }
  return {
    ...state
  };
}
function handleRemoveRealEstateAgent(state: ContractState, action: RemoveRealEstateAgentAction): ContractState {
  if (!state.contractVM) {
    return state;
  }
  if (action.all) {
    return {
      ...state,
      additionalRealEstateAgents: [],
      contractVM: {
        ...state.contractVM,
        additionalRealEstateAgentIds: []
      }
    };
  }

  var additionalRealEstateAgents = state.additionalRealEstateAgents;
  var additionalRealEstateAgentIds = state.contractVM.additionalRealEstateAgentIds;
  if (additionalRealEstateAgents && additionalRealEstateAgents.length > 0) {
    additionalRealEstateAgents = additionalRealEstateAgents.slice(0);
    additionalRealEstateAgents.splice(action.index, 1);
  }
  if (additionalRealEstateAgentIds && additionalRealEstateAgentIds.length > 0) {
    additionalRealEstateAgentIds = additionalRealEstateAgentIds.slice(0);
    additionalRealEstateAgentIds.splice(action.index, 1);
  }
  return {
    ...state,
    additionalRealEstateAgents: additionalRealEstateAgents,
    contractVM: {
      ...state.contractVM,
      additionalRealEstateAgentIds: additionalRealEstateAgentIds
    }
  };
}

function handleGetAssetManagersStart(state: ContractState, action: GetAssetManagersStartAction): ContractState {
  return {
    ...state,
    message: 'GETTING ASSET MANAGERS'
  };
}

function handleGetAssetManagersSuccess(state: ContractState, action: GetAssetManagersSuccessAction): ContractState {
  if (!action.assetManagers) {
    return state;
  }

  return {
    ...state,
    assetManagers: action.assetManagers,
    message: 'SUCCESS - get asset managers done'
  };
}

function handleGetAssetManagersFailure(state: ContractState, action: GetAssetManagersFailureAction): ContractState {
  return {
    ...state,
    message: action.errorMessage
  };
}

/********** SearchCommentsByContract **********/
function handleSearchCommentsByContractInit(
  state: ContractState,
  action: SearchCommentsByContractInitAction
): ContractState {
  return {
    ...state,
    message: 'Search Init!',
    // searchQuery: action.query,
    commentsLoading: true
  };
}
function handleSearchCommentsByContractFailure(
  state: ContractState,
  action: SearchCommentsByContractFailureAction
): ContractState {
  return {
    ...state,
    message: action.errorMessage,
    commentsLoading: false
  };
}
function handleSearchCommentsByContractSuccess(
  state: ContractState,
  action: SearchCommentsByContractSuccessAction
): ContractState {
  return {
    ...state,
    message: 'Search Success!',
    commentsLoading: false,
    commentsPageCount: Math.ceil(action.searchResult.totalResults / action.searchResult.pageSize),
    commentsPageNumber: action.pageNumber,
    commentsPageSize: action.pageSize,
    commentsResults: action.searchResult.results
  };
}

function handleSelectComment(state: ContractState, action: SelectCommentAction): ContractState {
  return {
    ...state,
    selectedCommentText: action.commentText
  };
}

function handleContractLoadRealEstateAgentsStart(
  state: ContractState,
  action: GeneralLoadRealEstateAgentsAction
): ContractState {
  const newAgents = {
    ...state.loadingContractAgents,
    [action.agentId]: action.agentType
  };
  return {
    ...state,
    loadingContractAgents: newAgents
  };
}

function handleContractLoadRealEstateAgentsFailure(
  state: ContractState,
  action: GeneralLoadRealEstateAgentsAction
): ContractState {
  return {
    ...state
  };
}

function handleConvertQuoteToContract(state: ContractState, action: ConvertQuoteToContractAction): ContractState {
  // calculate pricing for total buyer and seller price
  const sellerTotalPrice = action.quote.coverageOptions
    .map(option => +option.sellersPrice || 0)
    .reduce((a, b) => a + b);
  const buyerTotalPrice = action.quote.coverageOptions.map(option => +option.price || 0).reduce((a, b) => a + b);
  const totalPrice = sellerTotalPrice + buyerTotalPrice;

  let newContractVM: ContractViewModel = {
    ...action.quote,
    id: -1,
    contractAn: '',
    coverageOptions: action.quote.coverageOptions,
    assetManager: {} as OptionsViewModel,
    assetManagerId: 0,
    assetId: '',
    buyerId: 0,
    coopAgentId: 0,
    coopOfficeId: 0,
    coopSamId: 0,
    comprehensiveOption: false,
    coverageDate: new Date(),
    employeeDiscount: {} as PriceAdjustmentViewModel,
    escrowOfficerId: 0,
    escrowId: 0,
    escrowOneTimeFax: '',
    estimatedCoeDate: new Date(),
    escrowComments: '',
    initAgentId: 0,
    initOfficeId: 0,
    initSamId: 0,
    productGroup: {
      id: action.quote.product.productGroupId
    } as OptionsViewModel,
    productChannel: {
      id: action.quote.product.productChannelId
    } as OptionsViewModel,
    propertyManagerId: 0,
    priceAdjustment: action.quote.priceAdjustment,
    priceAdjustmentAmount: action.quote.priceAdjustmentAmount,
    priceAdjustmentNotes: action.quote.priceAdjustmentNotes,
    orderDate: new Date(),
    sellerCoverage: action.quote.sellerCoverage,
    sellerCoverageDate: new Date(),
    sellerCoverageEndDate: new Date(),
    firstBilling: {} as OptionsViewModel,
    laterBilling: {} as OptionsViewModel,
    sellerId: 0,
    transactionCoordinatorIds: [],
    txCOneTimeFax: '',
    additionalRealEstateAgentIds: [],
    fileNumber: '',
    transCoordId: 0,
    contractEntities: [],
    contractStatus: {} as OptionsViewModel,
    extraCharge: 0,
    noRenew: {} as NoRenewViewModel,
    noRenewReasons: {} as OptionsViewModel,
    yearBuilt: action.quote.yearBuilt
  } as ContractViewModel;
  return {
    ...state,
    contractVM: newContractVM,
    totalPrice: totalPrice
    /* buyerTotalPrice: buyerTotalPrice,
         sellerTotalPrice: sellerTotalPrice,
         selectedProduct: action.quote.product,
         selectedCoverageOptions: action.quote.coverageOptions,
         priceAdjustmentId: action.quote.priceAdjustment.id,
         priceAdjustmentAmount: action.quote.priceAdjustmentAmount,
         priceAdjustmentIncrease: action.quote.priceAdjustment.increase, */
  };
}

function handleResellContract(state: ContractState, action: ContractResellAction): ContractState {
  const sellerTotalPrice = action.contractVM.coverageOptions
    .map(option => +option.sellersPrice || 0)
    .reduce((a, b) => a + b);
  const buyerTotalPrice = action.contractVM.coverageOptions.map(option => +option.price || 0).reduce((a, b) => a + b);
  const totalPrice = sellerTotalPrice + buyerTotalPrice;

  return {
    ...state,
    contractVM: action.contractVM,
    // selectedCoverageOptions: action.contractVM.coverageOptions,
    totalPrice: totalPrice
    // buyerTotalPrice: buyerTotalPrice,
    // sellerTotalPrice: sellerTotalPrice
    // selectedProduct: action.contractVM.product,
    /* initAgent: action.agent,
    initOffice: action.office,
    coopAgent: action.coopagent,
    coopOffice: action.coopAgentOffice */
  };
}

/********** SaveContractFiles **********/
function handleSaveContractFilesStart(state: ContractState, action: SaveContractFilesStartAction): ContractState {
  return state;
}
function handleSaveContractFilesSuccess(state: ContractState, action: SaveContractFilesSuccessAction): ContractState {
  if (!action.documents) {
    return state;
  }
  return {
    ...state,
    message: 'SUCCESS - contract files saved - ' + action.contractId
  };
}
function handleSaveContractFilesFailure(state: ContractState, action: SaveContractFilesFailureAction): ContractState {
  if (!action.errorMessage) {
    return state;
  }
  return {
    ...state,
    message: 'ERROR - save contract files failed - ' + action.errorMessage
  };
}

/********** RemoveContractFile **********/
function handleRemoveContractFileStart(state: ContractState, action: RemoveContractFileStartAction): ContractState {
  return state;
}
function handleRemoveContractFileSuccess(state: ContractState, action: RemoveContractFileSuccessAction): ContractState {
  if (!action.fileId) {
    return state;
  }
  return {
    ...state,
    message: 'SUCCESS - contract file removed - ' + action.contractId
  };
}
function handleRemoveContractFileFailure(state: ContractState, action: RemoveContractFileFailureAction): ContractState {
  if (!action.errorMessage) {
    return state;
  }
  return {
    ...state,
    message: 'ERROR - remove contract file failed - ' + action.errorMessage
  };
}

/********** GetContractFiles **********/
function handleGetContractFilesStart(state: ContractState, action: GetContractFilesStartAction): ContractState {
  return state;
}
function handleGetContractFilesSuccess(state: ContractState, action: GetContractFilesSuccessAction): ContractState {
  if (!action.contractId) {
    return state;
  }
  return {
    ...state,
    message: 'SUCCESS - get contract files done - ' + action.contractId,
    documents: action.documents
  };
}
function handleGetContractFilesFailure(state: ContractState, action: GetContractFilesFailureAction): ContractState {
  if (!action.errorMessage) {
    return state;
  }
  return {
    ...state,
    message: 'ERROR - get contract files failed - ' + action.errorMessage
  };
}

/********** GetEdocTypes **********/
function handleGetEdocTypesStart(state: ContractState, action: GetEdocTypesStartAction): ContractState {
  return state;
}
function handleGetEdocTypesSuccess(state: ContractState, action: GetEdocTypesSuccessAction): ContractState {
  if (!action.edocTypes) {
    return state;
  }
  return {
    ...state,
    message: 'SUCCESS - get edoc types done',
    edocTypes: action.edocTypes
  };
}
function handleGetEdocTypesFailure(state: ContractState, action: GetEdocTypesFailureAction): ContractState {
  if (!action.errorMessage) {
    return state;
  }
  return {
    ...state,
    message: 'ERROR - get edoc types failed - ' + action.errorMessage
  };
}

/***** Cancel Contract ********/
function handleCancelContractOrderStart(state: ContractState, action: CancelContractOrderStartAction): ContractState {
  return state;
}

function handleCancelContractOrderSuccess(
  state: ContractState,
  action: CancelContractOrderSuccessAction
): ContractState {
  return {
    ...state,
    message: action.message
  };
}

function handleGetContractCancellationReasonsStart(
  state: ContractState,
  action: GetContractCancellationReasonsStartAction
): ContractState {
  return {
    ...state,
    message: action.type
  };
}

function handleGetContractCancellationReasonsSuccess(
  state: ContractState,
  action: GetContractCancellationReasonsSuccessAction
): ContractState {
  return {
    ...state,
    contractCancellationReasons: action.reasons
  };
}

function handleGetContractCancellationReasonsFailure(
  state: ContractState,
  action: GetContractCancellationReasonsFailureAction
): ContractState {
  return {
    ...state,
    message: action.errorMessage
  };
}

function handleCancelContractOrderFailure(
  state: ContractState,
  action: CancelContractOrderFailureAction
): ContractState {
  return {
    ...state,
    message: action.errorMessage
  };
}

function handleSetCancellationRefund(state: ContractState, action: SetCancellationRefundAction): ContractState {
  return {
    ...state,
    refund: action.refundInfo
  };
}

function handleCalculateContractCancellationStart(
  state: ContractState,
  action: CalculateContractCancellationRefundStartAction
): ContractState {
  return {
    ...state,
    message: action.type
  };
}

function handleCalculateContractCancellationSuccess(
  state: ContractState,
  action: CalculateContractCancellationRefundSuccessAction
): ContractState {
  return {
    ...state,
    refund: action.refund
  };
}

function handleCalculateContractCancellationFailure(
  state: ContractState,
  action: CalculateContractCancellationRefundFailureAction
): ContractState {
  return {
    ...state,
    message: action.errorMessage
  };
}

function handleGetContractCancellationNotificationssStart(
  state: ContractState,
  action: GetContractCancellationNotificationsStartAction
): ContractState {
  return {
    ...state,
    message: action.type
  };
}

function handleGetContractCancellationNotificationsSuccess(
  state: ContractState,
  action: GetContractCancellationNotificationsSuccessAction
): ContractState {
  return {
    ...state,
    cancellationNotifications: action.cancellationNotifications
  };
}

function handleGetContractCancellationNotificationsFailure(
  state: ContractState,
  action: GetContractCancellationNotificationsFailureAction
): ContractState {
  return {
    ...state,
    message: action.errorMessage
  };
}

function handleAddEmailNotification(state: ContractState, action: AddEmailNotificationAction): ContractState {
  if (action.email.length === 0 || state.emailNotifications.indexOf(action.email) >= 0 || !isValidEmail(action.email)) {
    return {
      ...state
    };
  }

  return {
    ...state,
    emailNotifications: [...state.emailNotifications, action.email]
  };
}

function handleRemoveEmailNotification(state: ContractState, action: RemoveEmailNotificationAction): ContractState {
  return {
    ...state,
    emailNotifications: state.emailNotifications.filter(notification => notification !== action.email)
  };
}

function handleSetOverride(state: ContractState, action: SetOverrideAction): ContractState {
  return {
    ...state,
    addressOverride: action.value
  };
}

function handleSetRefundByCheck(state: ContractState, action: SetRefundByCheckAction): ContractState {
  return {
    ...state,
    refundByCheck: action.value
  };
}

function handleSetPaymentInfo(state: ContractState, action: SetPaymentInfoAction): ContractState {
  return {
    ...state,
    paymentInfo: action.paymentInfo
  };
}

function handleResetContractCancellationForm(
  state: ContractState,
  action: ContractCancellationFormResetAction
): ContractState {
  return {
    ...state,
    refund: null,
    cancellationNotifications: [],
    emailNotifications: [],
    addressOverride: false,
    refundByCheck: false
  };
}

/**** Resale Contract ****/

function handleGetContractResaleDataStart(
  state: ContractState,
  action: GetContractResaleDataStartAction
): ContractState {
  return {
    ...state
  };
}

function handleSetResaleLoading(state: ContractState, action: SetResaleLoadingAction): ContractState {
  return {
    ...state,
    isLoadingResale: action.isLoading
  };
}

function handleGetContractResaleDataSuccess(
  state: ContractState,
  action: GetContractResaleDataSuccessAction
): ContractState {
  return {
    ...state,
    contractResaleModalVM: action.contractResaleModalVM,
    isLoadingResale: false
  };
}

function handleGetContractResaleDataFailure(
  state: ContractState,
  action: GetContractResaleDataFailureAction
): ContractState {
  return {
    ...state,
    message: action.message,
    isLoadingResale: false
  };
}

function handleClearResaleData(state: ContractState, action: ClearResaleDataAction): ContractState {
  return {
    ...state,
    contractResaleModalVM: undefined
  };
}

function handleSaveResaleContractStart(state: ContractState, action: SaveResaleContractStartAction): ContractState {
  return {
    ...state
  };
}

function handleSaveResaleContractSuccess(state: ContractState, action: SaveResaleContractSuccessAction): ContractState {
  return {
    ...state,
    id: action.id
  };
}

function handleGetContractResaleNotificationsStart(
  state: ContractState,
  action: GetContractResaleNotificationsStartAction
): ContractState {
  return {
    ...state
  };
}

function handleGetContractResaleNotificationsSuccess(
  state: ContractState,
  action: GetContractResaleNotificationsSuccessAction
): ContractState {
  return {
    ...state,
    resaleNotifications: action.resaleNotifications
  };
}

function handleGetContractResaleNotificationsFailure(
  state: ContractState,
  action: GetContractResaleNotificationsFailureAction
): ContractState {
  return {
    ...state,
    message: action.error
  };
}

function handleSaveResaleContractFailure(state: ContractState, action: SaveResaleContractFailureAction): ContractState {
  return {
    ...state,
    message: action.error
  };
}

function handleContractResaleAddEmailNotification(
  state: ContractState,
  action: AddEmailNotificationAction
): ContractState {
  if (
    action.email.length === 0 ||
    state.resaleEmailNotifications.indexOf(action.email) >= 0 ||
    !isValidEmail(action.email)
  ) {
    return {
      ...state
    };
  }

  return {
    ...state,
    resaleEmailNotifications: [...state.resaleEmailNotifications, action.email]
  };
}

function handleContractResaleRemoveEmailNotification(
  state: ContractState,
  action: RemoveEmailNotificationAction
): ContractState {
  return {
    ...state,
    resaleEmailNotifications: state.resaleEmailNotifications.filter(notification => notification !== action.email)
  };
}

function handleSendResaleEmailsStart(state: ContractState, action: SendResaleEmailsStartAction): ContractState {
  return {
    ...state
  };
}

function handleSendResaleEmailsSuccess(state: ContractState, action: SendResaleEmailsSuccessAction): ContractState {
  return {
    ...state,
    sentEmails: true
  };
}

function handleSendResaleEmailsFailure(state: ContractState, action: SendResaleEmailsFailureAction): ContractState {
  return {
    ...state,
    message: action.message
  };
}

/************ Get Renewal Contract ************/
function handleGetRenewalContractStart(state: ContractState, action: GetRenewalContractStartAction): ContractState {
  return {
    ...state,
    message: 'GETTING RENEWAL CONTRACT'
  };
}
function handleGetRenewalContractSuccess(state: ContractState, action: GetRenewalContractSuccessAction): ContractState {
  if (!action.contractVM) {
    return state;
  }

  return {
    ...state,
    id: action.contractVM.id,
    contractVM: action.contractVM,
    message: 'SUCCESS - get renewal contract done - ' + action.contractVM.id,
    totalPrice: action.contractVM.totalPrice
  };
}
function handleGetRenewalContractFailure(state: ContractState, action: GetRenewalContractFailureAction): ContractState {
  if (!action.errorMessage) {
    return state;
  }

  return {
    ...state,
    message: 'ERROR - get renewal contract failed - ' + action.errorMessage
  };
}

function handleGetRenewalOptionsStart(state: ContractState, action: GetRenewalOptionsStartAction): ContractState {
  return {
    ...state,
    message: 'GETTING RENEWAL OPTIONS',
    id: action.id,
    searchLoading: true
  };
}
function handleGetRenewalOptionsSuccess(state: ContractState, action: GetRenewalOptionsSuccessAction): ContractState {
  return {
    ...state,
    message: 'Search Success!',
    searchLoading: false,
    searchPageCount: Math.ceil(action.searchResult.totalResults / action.searchResult.pageSize),
    searchPageNumber: action.pageNumber,
    searchPageSize: action.pageSize,
    renewalOptions: action.searchResult.results,
    searchResultsTotalCount: action.searchResult.totalResults
  };
}
function handleGetRenewalOptionsFailure(state: ContractState, action: GetRenewalOptionsFailureAction): ContractState {
  return {
    ...state,
    message: action.errorMessage,
    searchLoading: false
  };
}

/************ Send Renewal Notice ************/
function handleSendRenewalNoticeStart(state: ContractState, action: SendRenewalNoticeStartAction): ContractState {
  return {
    ...state,
    message: 'SENDING RENEWAL NOTICE'
  };
}
function handleSendRenewalNoticeSuccess(state: ContractState, action: SendRenewalNoticeSuccessAction): ContractState {
  return {
    ...state,
    message: 'SUCCESS - send renewal notice done'
  };
}
function handleSendRenewalNoticeFailure(state: ContractState, action: SendRenewalNoticeFailureAction): ContractState {
  if (!action.errorMessage) {
    return state;
  }

  return {
    ...state,
    message: 'ERROR - send renewal notice failed - ' + action.errorMessage
  };
}

function handleSaveCoverageStep(state: ContractState, action: SaveCoverageAction) {
  const value = action.value;

  let contractVM: ContractViewModel = {
    ...state.contractVM,
    coverageOptions: value.selectedCoverageOptions,
    sellerCoverage: value.sellerCoverage
  } as ContractViewModel;
  contractVM.totalPrice = value.totalPrice;
  contractVM.extraCharge = value.extraCharge;

  if (value) {
    if (value.selectedProduct) {
      contractVM.product = value.selectedProduct;
    }

    if (value.selectedProductChannel) {
      contractVM.productChannel = value.selectedProductChannel;
    }

    if (value.selectedProductGroup) {
      contractVM.productGroup = value.selectedProductGroup;
    }

    contractVM.priceAdjustment = value.selectedPriceAdjustment || ({} as PriceAdjustmentViewModel);

    contractVM.priceAdjustmentAmount =
      value.overridePriceAdjustmentAmount ||
      (value.selectedPriceAdjustment ? value.selectedPriceAdjustment.adjustmentAmount : 0);

    contractVM.priceAdjustmentNotes = value.priceAdjustmentNotes || '';

    if (value.selectedEmployeeDiscount) {
      contractVM.priceAdjustmentAmount = -value.totalAdjustments;
    }

    contractVM.employeeDiscount = value.selectedEmployeeDiscount || ({} as PriceAdjustmentViewModel);
    contractVM.sellerCoverage = value.sellerCoverage;
  }
  return {
    ...state,
    contractVM: contractVM,
    totalAdjustment: value.totalAdjustments,
    totalPrice: value.totalPrice
  };
}

function handleActivateContractFailure(state: ContractState, action: ActivateContractFailureAction): ContractState {
  return state;
}

function handleActivateContractStart(state: ContractState, action: ActivateContractStartAction): ContractState {
  return state;
}

function handleActivateContractSuccess(state: ContractState, action: ActivateContractSuccessAction): ContractState {
  return {
    ...state,
    contractDetailsVM: {
      ...state.contractDetailsVM!,
      metadata: {
        ...state.contractDetailsVM!.metadata,
        eligibleForActivation: false
      },
      termStart: action.coeDate
    }
  };
}

/******** Contract NoRenew *********/
function handleNoRenewContractStart(state: ContractState, action: NoRenewContractStartAction): ContractState {
  return state;
}

function handleNoRenewContractSuccess(state: ContractState, action: NoRenewContractSuccessAction): ContractState {
  return {
    ...state,
    noRenew: action.currentNoRenewVM
  };
}

function handleNoRenewContractFailure(state: ContractState, action: NoRenewContractFailureAction): ContractState {
  return {
    ...state,
    message: action.type
  };
}

/**** Get Contract NoRenew Reasons  ******/
function handleGetContractNoRenewReasonsStart(
  state: ContractState,
  action: GetContractNoRenewReasonsStartAction
): ContractState {
  return state;
}

function handleGetContractNoRenewReasonsSuccess(
  state: ContractState,
  action: GetContractNoRenewReasonsSuccessAction
): ContractState {
  return {
    ...state,
    noRenewReasons: action.noRenewReasons
  };
}

function handleGetContractNoRenewReasonsFailure(
  state: ContractState,
  action: GetContractNoRenewReasonsFailureAction
): ContractState {
  return {
    ...state,
    message: action.errorMessage
  };
}

/******** Remove NoRenew *********/
function handleRemoveNoRenewContractStart(
  state: ContractState,
  action: RemoveNoRenewContractStartAction
): ContractState {
  return state;
}

function handleRemoveNoRenewContractSuccess(
  state: ContractState,
  action: RemoveNoRenewContractSuccessAction
): ContractState {
  return {
    ...state,
    noRenew: {} as NoRenewViewModel
    // noRenewCd: 0,
    // noRenewDate: null,
    // noRenewDs: undefined
    // }
  };
}

function handleRemoveNoRenewContractFailure(
  state: ContractState,
  action: RemoveNoRenewContractFailureAction
): ContractState {
  return {
    ...state,
    message: action.type
  };
}

function handleResetContractState(state: ContractState, action: ResetContractStateAction): ContractState {
  return {
    ...initialState
  };
}

function handleSetContractMetadata(state: ContractState, action: SetContractMetadataAction): ContractState {
  return {
    ...state,
    contractMetadata: action.contractMetadata
  };
}

function handleLoadPropertyWorkflow(state: ContractState, action: LoadPropertyWorkflowAction): ContractState {
  return {
    ...state,
    contractVM: {
      ...state.contractVM!,
      propertyType: action.propertyInfo.propertyType,
      propertySaleType: action.propertyInfo.propertySaleType,
      propertyAddress: action.propertyInfo.propertyAddress,
      yearBuilt: action.propertyInfo.yearBuilt,
      contactName: action.propertyInfo.contactName,
      contactType: action.propertyInfo.contactType,
      contactMedium: action.propertyInfo.contactMedium,
      contactInit: action.propertyInfo.contactInit
    },
    orderType:
      action.propertyInfo && action.propertyInfo.propertySaleType
        ? action.propertyInfo.propertySaleType.id === PropertySaleTypes.DirectSale
          ? ContractOrderType.DTC
          : action.propertyInfo.propertySaleType.id === PropertySaleTypes.RealtyEscrow
            ? ContractOrderType.RealtyEscrow
            : ContractOrderType.Invalid
        : undefined
  };
}

function handleLoadAffiliatesWorkflow(state: ContractState, action: LoadAffiliatesWorkflowAction): ContractState {
  return {
    ...state,
    initAgent: action.initAgent,
    initOffice: action.initOffice,
    coopAgent: action.coopAgent,
    coopOffice: action.coopOffice,
    propertyManager: action.propertyManager
      ? ({
          ...action.propertyManager,
          phone: action.propertyManager.directPhone!,
          officeId: (action.propertyManager.propMgmtOffice! || {}).id,
          officeName: (action.propertyManager.propMgmtOffice! || {}).value,
          city: (action.propertyManager.address! || {}).city
        } as PropertyManagerSearchViewModel)
      : undefined,
    additionalRealEstateAgents: action.additionalAgents,
    escrowOfficer: action.escrowOfficer,
    escrowOffice: action.escrowOffice,
    contractVM: {
      ...state.contractVM!,
      transactionCoordinatorIds: action.transactionCoordinatorIds,
      escrowOneTimeFax: action.escrowOneTimeFax,
      txCOneTimeFax: action.txCOneTimeFax,
      fileNumber: action.fileNumber,
      estimatedCoeDate: action.estimatedCoeDate,
      initAgentId: action.initAgent && action.initAgent.id ? action.initAgent.id : 0,
      initOfficeId: action.initOffice && action.initOffice.id ? action.initOffice.id : 0,
      coopAgentId: action.coopAgent && action.coopAgent.id ? action.coopAgent.id : 0,
      coopOfficeId: action.coopOffice && action.coopOffice.id ? action.coopOffice.id : 0,
      escrowComments: action.escrowComments,
      escrowId: action.escrowOffice && action.escrowOffice.id ? action.escrowOffice.id : 0,
      escrowOfficerId: action.escrowOfficer && action.escrowOfficer.id ? action.escrowOfficer.id : 0,
      additionalRealEstateAgentIds: action.additionalRealEstateAgentIds
    },
    assetManagers: action.assetManagers
  };
}

function handleLoadCustomerWorkflow(state: ContractState, action: LoadCustomerWorkflowAction): ContractState {
  return {
    ...state,
    contractVM: {
      ...state.contractVM!,
      buyerId: action.buyerId,
      sellerId: action.sellerId,
      propertyManagerId: action.propertyManagerId
    }
  };
}

function handleLoadPriceAdjustmentWorkflow(
  state: ContractState,
  action: LoadPriceAdjustmentWorkflowAction
): ContractState {
  return {
    ...state,
    contractVM: {
      ...state.contractVM!,
      priceAdjustment: action.priceAdjustment,
      priceAdjustmentAmount: action.priceAdjustmentAmount,
      priceAdjustmentNotes: action.priceAdjustmentNotes
    }
  };
}

function handleSetContractId(state: ContractState, action: SetContractIdAction): ContractState {
  return {
    ...state,
    contractVM: {
      ...state.contractVM!,
      id: action.contractId
    }
  };
}

function handleSetIsOpenContract(state: ContractState, action: SetIsOpenContractAction): ContractState {
  return {
    ...state,
    isOpenContract: action.isOpenContract
  };
}

/********** SearchContractTerm ***********/
function handleSearchContractTermStart(state: ContractState, action: SearchContractTermStartAction): ContractState {
  return {
    ...state,
    historyLoading: true,
    historyQuery: action.query
  };
}
function handleSearchContractTermSuccess(state: ContractState, action: SearchContractTermSuccessAction): ContractState {
  return {
    ...state,
    historyLoading: false,
    historyOrderBy: action.orderBy,
    historyPageCount:
      action.result.totalResults <= 0 ? 0 : Math.ceil(action.result.totalResults / action.result.pageSize),
    historyPageSize: action.pageSize,
    historyResults: action.result.results
  };
}
function handleSearchContractTermFailure(state: ContractState, action: SearchContractTermFailureAction): ContractState {
  return {
    ...state,
    message: action.error,
    historyLoading: false
  };
}

function handleLoadOtherContractInfo(state: ContractState, action: LoadOtherContractInfoAction): ContractState {
  return {
    ...state,
    totalPrice: action.totalPrice,
    id: action.id
  };
}

/********** Search **********/
function handleSearchContractsInit(state: ContractState, action: SearchContractsInitAction): ContractState {
  return {
    ...state,
    message: 'Search Init!',
    searchQuery: action.query,
    searchLoading: true
  };
}
function handleSearchContractsFailure(state: ContractState, action: SearchContractsFailureAction): ContractState {
  return {
    ...state,
    message: action.errorMessage,
    searchLoading: false
  };
}
function handleSearchContractsSuccess(state: ContractState, action: SearchContractsSuccessAction): ContractState {
  return {
    ...state,
    message: 'Search Success!',
    searchLoading: false,
    searchPageCount: Math.ceil(action.searchResult.totalResults / action.searchResult.pageSize),
    searchPageNumber: action.pageNumber,
    searchPageSize: action.pageSize,
    searchResults: action.searchResult.results,
    searchResultsTotalCount: action.searchResult.totalResults
  };
}

function handleSetShouldClear(state: ContractState, action: SetShouldClearAction): ContractState {
  return {
    ...state,
    shouldClear: action.shouldClear
  };
}

/********** SearchRelated **********/
function handleSearchRelatedContractsInit(
  state: ContractState,
  action: SearchRelatedContractsInitAction
): ContractState {
  return {
    ...state,
    message: 'Search Related Init!',
    // searchQuery: action.query,
    searchLoading: true
  };
}

function handleSearchRelatedContractsFailure(
  state: ContractState,
  action: SearchRelatedContractsFailureAction
): ContractState {
  return {
    ...state,
    message: action.errorMessage,
    searchLoading: false
  };
}

function handleSearchRelatedContractsSuccess(
  state: ContractState,
  action: SearchRelatedContractsSuccessAction
): ContractState {
  return {
    ...state,
    message: 'Search Related Success!',
    relatedContractsLoading: false,
    relatedContractsPageCount: Math.ceil(action.searchResult.totalResults / action.searchResult.pageSize),
    relatedContractsPageNumber: action.pageNumber,
    relatedContractsPageSize: action.pageSize,
    relatedContractsResults: action.searchResult.results
  };
}

// take the current state and edit it with info from fields.

// This creates the reducer as redux wants it w/ a helper function
// There should an entry for each action type
const reducer = createReducer(initialState, {
  [ContractActionType.SaveContractStart]: handleSaveContractStart,
  [ContractActionType.SaveContractSuccess]: handleSaveContractSuccess,
  [ContractActionType.SaveContractFailure]: handleSaveContractFailure,
  [ContractActionType.SaveOrderType]: handleSaveOrderType,
  [ContractActionType.SavePropertyInfo]: handleSavePropertyInfo,
  [ContractActionType.SaveAffiliatesInfo]: handleSaveAffiliatesInfo,
  [ContractActionType.SaveCustomerInfo]: handleSaveCustomerInfo,
  [ContractActionType.SaveEscrowInfo]: handleSaveEscrowInfo,
  [ContractActionType.SaveCoeDate]: handleSaveCoeDate,

  [ContractActionType.GetContractDetailsStart]: handleGetContractDetailsStart,
  [ContractActionType.GetContractDetailsSuccess]: handleGetContractDetailsSuccess,
  [ContractActionType.GetContractDetailsFailure]: handleGetContractDetailsFailure,
  [ContractActionType.GetContactInitiatorsStart]: handleGetContactInitiatorsStart,
  [ContractActionType.GetContactInitiatorsSuccess]: handleGetContactInitiatorsSuccess,
  [ContractActionType.GetContactInitiatorsFailure]: handleGetContactInitiatorsFailure,
  [ContractActionType.GetContactMediumsStart]: handleGetContactMediumsStart,
  [ContractActionType.GetContactMediumsSuccess]: handleGetContactMediumsSuccess,
  [ContractActionType.GetContactMediumsFailure]: handleGetContactMediumsFailure,
  [ContractActionType.GetContactTypesStart]: handleGetContactTypesStart,
  [ContractActionType.GetContactTypesSuccess]: handleGetContactTypesSuccess,
  [ContractActionType.GetContactTypesFailure]: handleGetContactTypesFailure,
  [ContractActionType.GetPropertyTypesStart]: handleGetPropertyTypesStart,
  [ContractActionType.GetPropertyTypesSuccess]: handleGetPropertyTypesSuccess,
  [ContractActionType.GetPropertyTypesFailure]: handleGetPropertyTypesFailure,
  [ContractActionType.GetPropertySaleTypesStart]: handleGetPropertySaleTypesStart,
  [ContractActionType.GetPropertySaleTypesSuccess]: handleGetPropertySaleTypesSuccess,
  [ContractActionType.GetPropertySaleTypesFailure]: handleGetPropertySaleTypesFailure,
  [ContractActionType.GetBillingOptionsStart]: handleGetBillingOptionsStart,
  [ContractActionType.GetBillingOptionsSuccess]: handleGetBillingOptionsSuccess,
  [ContractActionType.GetBillingOptionsFailure]: handleGetBillingOptionsFailure,

  [ContractActionType.ContractLoadRealEstateAgentsStart]: handleContractLoadRealEstateAgentsStart,
  [ContractActionType.ContractLoadRealEstateAgentsFailure]: handleContractLoadRealEstateAgentsFailure,

  [ContractActionType.LoadInitiatingAgentSuccess]: handleLoadInitAgentSuccess,
  [ContractActionType.LoadCooperatingAgentSuccess]: handleLoadCoopAgentSuccess,
  [ContractActionType.LoadRealEstateAgentSuccess]: handleLoadRealEstateAgentSuccess,

  [ContractActionType.LoadEscrowOfficer]: handleLoadEscrowOfficer,
  [ContractActionType.LoadTransactionCoordinator]: handleLoadTransactionCoordinator,
  [ContractActionType.LoadBuyerCustomer]: handleLoadBuyerCustomer,
  [ContractActionType.LoadSellerCustomer]: handleLoadSellerCustomer,
  [ContractActionType.LoadEscrowOffice]: handleLoadEscrowOffice,
  [ContractActionType.LoadPropertyWorkFlow]: handleLoadPropertyWorkflow,
  [ContractActionType.LoadPropertyManager]: handleLoadPropertyManager,
  [ContractActionType.LoadCustomerWorkFlow]: handleLoadCustomerWorkflow,
  [ContractActionType.LoadAffiliatesWorkflow]: handleLoadAffiliatesWorkflow,
  [ContractActionType.LoadPriceAdjustmentWorkflow]: handleLoadPriceAdjustmentWorkflow,
  [ContractActionType.SetContractId]: handleSetContractId,
  [ContractActionType.SetIsOpenContract]: handleSetIsOpenContract,

  [ContractActionType.SavePaymentInfoStart]: handleSavePaymentInfoStart,
  [ContractActionType.SavePaymentInfoSuccess]: handleSavePaymentInfoSuccess,
  [ContractActionType.SavePaymentInfoFailure]: handleSavePaymentInfoFailure,

  [ContractActionType.ClearBuyer]: handleClearBuyer,
  [ContractActionType.ClearSeller]: handleClearSeller,
  [ContractActionType.ClearPropertyManager]: handleClearPropertyManager,
  [ContractActionType.ClearInitAgent]: handleClearInitAgent,
  [ContractActionType.ClearCoopAgent]: handleClearCoopAgent,
  [ContractActionType.ClearEscrowOfficer]: handleClearEscrowOfficer,
  [ContractActionType.ClearTransactionCoordinator]: handleClearTransactionCoordinator,

  [ContractActionType.RemoveTxC]: handleRemoveTxC,
  [ContractActionType.RemoveRealEstateAgent]: handleRemoveRealEstateAgent,

  [ContractActionType.GetAssetManagersStart]: handleGetAssetManagersStart,
  [ContractActionType.GetAssetManagersSuccess]: handleGetAssetManagersSuccess,
  [ContractActionType.GetAssetManagersFailure]: handleGetAssetManagersFailure,

  /********** SearchCommentsByContract **********/
  [ContractActionType.SearchCommentsByContractInit]: handleSearchCommentsByContractInit,
  [ContractActionType.SearchCommentsByContractFailure]: handleSearchCommentsByContractFailure,
  [ContractActionType.SearchCommentsByContractSuccess]: handleSearchCommentsByContractSuccess,

  [ContractActionType.SelectComment]: handleSelectComment,

  // Convert Quote To Contract
  [ContractActionType.ConvertQuoteToContract]: handleConvertQuoteToContract,
  /********** SaveContractFiles **********/
  [ContractActionType.SaveContractFilesStart]: handleSaveContractFilesStart,
  [ContractActionType.SaveContractFilesSuccess]: handleSaveContractFilesSuccess,
  [ContractActionType.SaveContractFilesFailure]: handleSaveContractFilesFailure,

  /********** RemoveContractFile **********/
  [ContractActionType.RemoveContractFileStart]: handleRemoveContractFileStart,
  [ContractActionType.RemoveContractFileSuccess]: handleRemoveContractFileSuccess,
  [ContractActionType.RemoveContractFileFailure]: handleRemoveContractFileFailure,

  /********** GetContractFiles **********/
  [ContractActionType.GetContractFilesStart]: handleGetContractFilesStart,
  [ContractActionType.GetContractFilesSuccess]: handleGetContractFilesSuccess,
  [ContractActionType.GetContractFilesFailure]: handleGetContractFilesFailure,

  /********** GetEdocTypes **********/
  [ContractActionType.GetEdocTypesStart]: handleGetEdocTypesStart,
  [ContractActionType.GetEdocTypesSuccess]: handleGetEdocTypesSuccess,
  [ContractActionType.GetEdocTypesFailure]: handleGetEdocTypesFailure,

  /******** CancelContractOrder *******/
  [ContractActionType.CancelContractOrderStart]: handleCancelContractOrderStart,
  [ContractActionType.CancelContractOrderSuccess]: handleCancelContractOrderSuccess,
  [ContractActionType.CancelContractOrderFailure]: handleCancelContractOrderFailure,

  /****** GetContractCancelReasons ******/
  [ContractActionType.GetContractCancellationReasonsStart]: handleGetContractCancellationReasonsStart,
  [ContractActionType.GetContractCancellationReasonsSuccess]: handleGetContractCancellationReasonsSuccess,
  [ContractActionType.GetContractCancellationReasonsFailure]: handleGetContractCancellationReasonsFailure,

  [ContractActionType.CalculateContractCancellationRefundStart]: handleCalculateContractCancellationStart,
  [ContractActionType.CalculateContractCancellationRefundSuccess]: handleCalculateContractCancellationSuccess,
  [ContractActionType.CalculateContractCancellationRefundFailure]: handleCalculateContractCancellationFailure,

  /***** Get Contract Cancel Notifications ****/
  [ContractActionType.GetContractCancellationNotificationsStart]: handleGetContractCancellationNotificationssStart,
  [ContractActionType.GetContractCancellationNotificationsSuccess]: handleGetContractCancellationNotificationsSuccess,
  [ContractActionType.GetContractCancellationNotificationsFailure]: handleGetContractCancellationNotificationsFailure,
  [ContractActionType.AddEmailNotification]: handleAddEmailNotification,
  [ContractActionType.RemoveEmailNotification]: handleRemoveEmailNotification,
  [ContractActionType.SetOverride]: handleSetOverride,
  [ContractActionType.SetRefundByCheck]: handleSetRefundByCheck,
  [ContractActionType.SetPaymentInfo]: handleSetPaymentInfo,
  [ContractActionType.SetCancellationRefund]: handleSetCancellationRefund,
  [ContractActionType.ContractCancellationFormReset]: handleResetContractCancellationForm,

  /****** Contract Resale *******/
  [ContractResaleActionType.ResellContract]: handleResellContract,
  [ContractResaleActionType.GetContractResaleDataStart]: handleGetContractResaleDataStart,
  [ContractResaleActionType.GetContractResaleDataSuccess]: handleGetContractResaleDataSuccess,
  [ContractResaleActionType.GetContractResaleDataFailure]: handleGetContractResaleDataFailure,
  [ContractResaleActionType.ClearResaleData]: handleClearResaleData,
  [ContractResaleActionType.SaveResaleContractStart]: handleSaveResaleContractStart,
  [ContractResaleActionType.SaveResaleContractSuccess]: handleSaveResaleContractSuccess,
  [ContractResaleActionType.SaveResaleContractFailure]: handleSaveResaleContractFailure,
  [ContractResaleActionType.GetContractResaleNotificationsStart]: handleGetContractResaleNotificationsStart,
  [ContractResaleActionType.GetContractResaleNotificationsSuccess]: handleGetContractResaleNotificationsSuccess,
  [ContractResaleActionType.GetContractResaleNotificationsFailure]: handleGetContractResaleNotificationsFailure,
  [ContractResaleActionType.AddEmailNotificationResale]: handleContractResaleAddEmailNotification,
  [ContractResaleActionType.RemoveEmailNotificationResale]: handleContractResaleRemoveEmailNotification,
  [ContractResaleActionType.SendResaleEmailsStart]: handleSendResaleEmailsStart,
  [ContractResaleActionType.SendResaleEmailsSuccess]: handleSendResaleEmailsSuccess,
  [ContractResaleActionType.SendResaleEmailsFailure]: handleSendResaleEmailsFailure,
  [ContractResaleActionType.SetResaleLoading]: handleSetResaleLoading,

  /************ Get Renewal Contract ************/
  [ContractActionType.GetRenewalContractStart]: handleGetRenewalContractStart,
  [ContractActionType.GetRenewalContractSuccess]: handleGetRenewalContractSuccess,
  [ContractActionType.GetRenewalContractFailure]: handleGetRenewalContractFailure,
  [ContractActionType.GetRenewalOptionsStart]: handleGetRenewalOptionsStart,
  [ContractActionType.GetRenewalOptionsSuccess]: handleGetRenewalOptionsSuccess,
  [ContractActionType.GetRenewalOptionsFailure]: handleGetRenewalOptionsFailure,

  /************ Send Renewal Notice ************/
  [ContractActionType.SendRenewalNoticeStart]: handleSendRenewalNoticeStart,
  [ContractActionType.SendRenewalNoticeSuccess]: handleSendRenewalNoticeSuccess,
  [ContractActionType.SendRenewalNoticeFailure]: handleSendRenewalNoticeFailure,

  /************ Activate Contract ************/
  [ContractActionType.ActivateContractFailure]: handleActivateContractFailure,
  [ContractActionType.ActivateContractStart]: handleActivateContractStart,
  [ContractActionType.ActivateContractSuccess]: handleActivateContractSuccess,

  [ContractActionType.SaveCoverageStep]: handleSaveCoverageStep,

  [ContractActionType.ClearContractDetails]: handleClearContractDetails,

  /************ Contract NoRenew ************/
  [ContractActionType.ContractNoRenewStart]: handleNoRenewContractStart,
  [ContractActionType.ContractNoRenewSuccess]: handleNoRenewContractSuccess,
  [ContractActionType.ContractNoRenewFailure]: handleNoRenewContractFailure,

  /************ Get Contract NoRenew Reasons  ************/
  [ContractActionType.GetContractNoRenewReasonsStart]: handleGetContractNoRenewReasonsStart,
  [ContractActionType.GetContractNoRenewReasonsSuccess]: handleGetContractNoRenewReasonsSuccess,
  [ContractActionType.GetContractNoRenewReasonsFailure]: handleGetContractNoRenewReasonsFailure,

  /************ Remove NoRenew ************/
  [ContractActionType.ContractRemoveNoRenewStart]: handleRemoveNoRenewContractStart,
  [ContractActionType.ContractRemoveNoRenewSuccess]: handleRemoveNoRenewContractSuccess,
  [ContractActionType.ContractRemoveNoRenewFailure]: handleRemoveNoRenewContractFailure,
  [ContractActionType.ResetContractState]: handleResetContractState,
  [ContractActionType.SetContractMetadata]: handleSetContractMetadata,

  /***** SearchContractTerm ******/
  [ContractHistoryActionType.SearchContractTermStart]: handleSearchContractTermStart,
  [ContractHistoryActionType.SearchContractTermSuccess]: handleSearchContractTermSuccess,
  [ContractHistoryActionType.SearchContractTermFailure]: handleSearchContractTermFailure,
  [ContractActionType.LoadOtherContractInfo]: handleLoadOtherContractInfo,

  [ContractActionType.SearchContractsInit]: handleSearchContractsInit,
  [ContractActionType.SearchContractsSuccess]: handleSearchContractsSuccess,
  [ContractActionType.SearchContractsFailure]: handleSearchContractsFailure,

  [ContractActionType.SearchRelatedContractsInit]: handleSearchRelatedContractsInit,
  [ContractActionType.SearchRelatedContractsFailure]: handleSearchRelatedContractsFailure,
  [ContractActionType.SearchRelatedContractsSuccess]: handleSearchRelatedContractsSuccess,

  /***** SavingUSPS ******/
  [ContractActionType.SavingUSPS]: handleSavingUSPS,

  [ContractActionType.SetShouldClear]: handleSetShouldClear
});

export const ContractReducer = combineReducersWithRoot(reducer, {
  payment: ContractPaymentReducer,
  orderEdit: OrderEditReducer,
  contractEmail: ContractEmailReducer,
  paymentEdit: PaymentEditReducer,
  contractBalances: ContractBalancesReducer
});



// WEBPACK FOOTER //
// ./src/contract/contract.reducer.ts